import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ru: {
    translation: {
      home: "Главная",
      courses: "Курсы",
      enroll: "Зарегистрироваться",
      videoCourses: "Видеокурсы",
      about: "О нас",
      contactUs: "Связаться с нами",
      fisrtBootcamp: "Первый буткемп в Туркменистане",
      startNew: "Начните свой новый  ",
      startNCont: "карьерный путь",
      bootcampTm: "с BootcampTM",
      enrollNow: "Запишитесь прямо сейчас",
      year: "год",
      experience: "опыт",
      students: "студенты",
      everySeason: "каждый сезон",
      qualified: "квалифицированный",
      teachers: "учителя",
      CoursesOffer: "Курсы, которые мы предлагаем",
      appDevelopment: "Разработка приложений",
      learn: "Узнайте, как создавать мобильные приложения  ",
      mobilApp: "для IOS и Android в Bootcamp",
      qualifiedTeacher: "с квалифицированными преподавателями.",
      viewDetails: "Посмотреть детали",
      fullStack: "Интернет с полным стеком",
      development: "разработка",
      webDeveloper:
        "Веб-разработчик — очень востребованная профессия в наше время. Станьте полноценным разработчиком в BootcampTm.",
      learnDesign:
        "Узнайте, как создавать уникальные фирменные стили, дизайн продуктов и пользовательский интерфейс.",
      productDesign: "Дизайн продукта",
      dataAnalytics: "Аналитика данных и бизнес-аналитика",
      inThisCourse:
        "В этом курсе вы узнаете, как работать с большими данными и как управлять большим объемом информации.",
      whenCome: "Когда дело доходит до",
      bootcampIt: "Bootcamp, это",
      never: "никогда",
      late: "поздно",
      to: "к",
      learN: "учиться",
      bootcampUnique: "Что делает наш BootcampTm уникальным?",
      affordable: "Доступный",
      bootcampPayment:
        "BootcampTM создан для того, чтобы у людей появился еще один шанс сделать карьеру в сфере ИТ, поэтому мы предлагаем всем доступные тарифные планы.",
      professionalSupport: "Профессиональная поддержка",
      everyBatch:
        "В каждой группе есть ограниченное количество студентов, поэтому инструкторы, наставники и команда поддержки знают каждого студента по имени и поддерживают их во всем, что им нужно.",
      dynamicCurriculum: "Динамичный учебный план",
      everySession:
        "Каждая сессия отличается. Мы верим в предоставление современных знаний, которые соответствуют современным технологиям и тенденциям.",
      studentProcess: "Студенческий Процесс",
      apply: "Применять",
      readDetails:
        "Прочтите информацию об интересующем вас домене. Зарегистрируйтесь, зарегистрировавшись на конкретный курс.",
      register: "Pегистр",
      signContract: "Подписать контракт. Подготовьтесь к курсу.",
      orientation: "Ориентация",
      comeToOrientation:
        "Приходите на ориентацию. Начать урок. Знать правила и положения. Установка необходимых инструментов и получение доступа к учебным материалам.",
      careerPreparation: "Поддержка при подготовке к карьере",
      prepareResume:
        "Подготовьте своего профессионала резюме. Подготовьте описание проекта.",
      marketSupport: "Поддержка рынка",
      followUp:
        "Следовать за. Обзорные сессии. Сессии выпускников. Поддержка 1 на 1. Рекомендации и поддержка от наших партнеров по подбору персонала. Делитесь публикациями о вакансиях. Другая помощь в работе по мере необходимости.",
      finalInterview: "Заключительное интервью",
      finalProject: "Последний проект. интервью МОЦ. Наставничество.",
      graduate: "Выпускник",
      acquireCertification:
        "Получите сертификацию в выбранном домене. Готовьтесь к новой карьере.",
      startNewCareer: "Начать новую карьеру",
      encounterManifold:
        "Откройте для себя множество возможностей карьерного роста в своей области.",
      launchLife: "Запустить жизнь",
      sliderText:
        "Я Людмила. Я инженер по контролю качества в промышленном строительстве. Когда я был моложе, я слышал много историй от дедушки, который был инженером-строителем. Истории вдохновили меня в конечном итоге стать инженером. Мой совет женщине..Я Людмила. Я инженер по контролю качества в промышленном строительстве. Когда я был моложе, я слышал много историй от дедушки, который был инженером-строителем.",
      whatOurStudentsSay: "Что говорят наши студенты",
      leaveFeedback: "Оставить отзыв",
      ourPartners: "Наши партнеры",
      weMake: "Мы делаем",
      learning: "обучение",
      engaging: "привлечение",
      chooseYourDesired: "Выберите нужные курсы или вебинары",
      enrollToday: "Зарегистрируйтесь сегодня",
      signintoContinue: "Войдите, чтобы продолжить",
      password: "Пароль",
      login: "Авторизоваться",
      signup: "Зарегистрироваться",
      continue: "Продолжать",
      signuptoLearnMore: "Зарегистрируйтесь, чтобы узнать больше",
      confirmPassword: "Подтвердите пароль",
      required: "Необходимый",
    },
  },
  tm: {
    translation: {
      home: "Baş sahypa",
      courses: "Kurslar",
      enroll: "Bellige al",
      videoCourses: "Video Kurslary",
      about: "Biz Barada",
      contactUs: "Habarlaşmak",
      fisrtBootcamp: "Türkmenistanda ilkinji Bootcamp",
      startNew: "Täze karýera syýahatyňyzy",
      bootcampTm: "BootcampTm",
      startNCont: "bilen başlaň",
      enrolNow: "Şu wagt ýazylyň",
      year: "ýyl",
      experience: "tejribe",
      students: "okuwçylar",
      everySeason: "her möwsüm",
      qualified: "hünärli",
      teachers: "mugallymlar",
      CoursesOffer: "Biziň hödürleýän kurslarymyz",
      appDevelopment: "Programma düzmek",
      learn: "IOS we Android ykjam programmalary",
      mobilApp: "Bootcamp-yň ökde mugallymlar bilen",
      qualifiedTeacher: "nädip döretmelidigini öwreniň.",
      viewDetails: "Jikme-jiklikleri görüň",
      fullStack: "Doly web",
      development: "ösüş",
      webDeveloper:
        "Web dörediji häzirki döwürde gaty zerur hünärdir. BootcampTm-de doly stack dörediji boluň.",
      learnDesign:
        "Üýtgeşik marka aýratynlyklaryny, önüm dizaýnyny we ulanyjy interfeýsini nädip düzmelidigini öwreniň",
      productDesign: "Önüm dizaýny",
      dataAnalytics: "Maglumatlaryň seljerişi we iş aňy",
      inThisCourse:
        "Bu kursda uly maglumatlar bilen işlemegi we köp mukdarda maglumaty nädip dolandyrmalydygyny öwreniň",
      whenCome: "Bu barada aýdylanda",
      bootcampIt: "Bootcamp, bu",
      never: "hiç haçan",
      late: "öwrenmek üçin ",
      to: "",
      learN: "giç däl",
      bootcampUnique: "BootcampTm-ymyzy näme üýtgeşik edýär?",
      affordable: "Amatly",
      bootcampPayment:
        "BootcampTm, IT karýerasynda başga bir mümkinçiligi bolan adamlar hakda, şonuň üçin hemmelere elýeterli töleg meýilnamalaryny hödürleýäris.",
      professionalSupport: "Hünär goldawy",
      everyBatch:
        "Her toparyň çäkli mukdary bar, şonuň üçin mugallymlar, terbiýeçiler we goldaw topary her bir okuwçynyň adyny bilýärler we zerur zatlarynda goldaw berýärler.",
      dynamicCurriculum: "Dinamiki okuw meýilnamasy",
      everySession:
        "Her sessiýa başga. Häzirki tehnologiýa we tendensiýa laýyk gelýän häzirki zaman bilimleri bermäge ynanýarys.",
      studentProcess: "Talyp Prosesi",
      apply: "Giriş",
      readDetails:
        "Özüňizi gyzyklandyrýan domeniň jikme-jikliklerini okaň. Belli bir ders üçin hasaba durmak bilen özüňizi ýazyň.",
      register: "Hasaba al",
      signContract: "Şertnama gol çekiň. Kursa taýyn boluň.",
      orientation: "Ugrukdyrma",
      comeToOrientation:
        "Ugruna geliň. Sapagy başlaň. Düzgünleri we düzgünleri biliň. Zerur gurallary gurmak we okuw materiallaryna girmek.",
      careerPreparation: "Hünär taýýarlygy goldawy",
      prepareResume:
        "Hünärmeniňizi taýýarlaň dowam et. Taslamanyň beýanyny taýýarlaň.",
      marketSupport: "Bazar goldawy",
      followUp:
        "Yzarla. Sessiýalary gözden geçiriň. Uçurymlaryň sapaklary. 1-den-1 goldaw. Işe alýan hyzmatdaşlarymyzyň salgylanmalary we goldawy. Iş orunlaryny paýlaşmak Zerur bolanda beýleki iş goldawy.",
      finalInterview: "Jemleýji söhbetdeşlik",
      finalProject: "Jemleýji taslama. MOC bilen söhbetdeşlik. Mugallymçylyk.",
      graduate: "Uçurym",
      acquireCertification:
        "Saýlanan domende şahadatnama alyň. Täze karýera taýynlaň.",
      startNewCareer: "Täze karýera başlaň",
      encounterManifold:
        "Domeniňizde köp gezek karýera mümkinçilikleri bilen duşuşyň.",
      launchLife: "Durmuşy başlaň",
      sliderText:
        "Men Lýudmila. Senagat gurluşygynda hil gözegçiligi inereneri. Men kiçi wagtym gurluşyk inereneri atamdan köp hekaýa eşitdim. Hekaýalar meni ahyrsoňy inerener bolmaga ruhlandyrdy. Aýal üçin maslahatym..Men Lýudmila. Senagat gurluşygynda hil gözegçiligi inereneri. Men kiçi wagtym gurluşyk inereneri atamdan köp hekaýa eşitdim.",
      whatOurStudentsSay: "Okuwçylarymyzyň aýdýanlary",
      leaveFeedback: "Ters jogap beriň",
      ourPartners: "Hyzmatdaşlarymyz",
      weMake: "Biz ýasaýarys",
      learning: "öwrenmek",
      engaging: "çekmek",
      chooseYourDesired: "Isleýän kurslaryňyzy ýa-da webinarlaryňyzy saýlaň",
      enrollToday: "Şu gün ýazyň",
      signintoContinue: "Dowam etmek üçin giriň",
      password: "Parol",
      login: "Giriş",
      signup: "Hasaba giriň",
      continue: "Dowam et",
      signuptoLearnMore: "Has giňişleýin öwrenmek üçin ýazylyň",
      confirmPassword: "Paroly tassykla",
      required: "Gerekli",
    },
  },

  en: {
    translation: {
      home: "Home",
      courses: "Courses",
      enroll: "Enroll",
      videoCourses: "Video Courses",
      about: "About",
      contactUs: "Contact Us",
      fisrtBootcamp: "First Bootcamp in Turkmenistan",
      startNew: "Start your new",
      startNCont: "career journey with",
      bootcampTm: "BootcampTm",
      enrolNow: "Enroll right now",
      year: "year",
      experience: "experience",
      students: "students",
      everySeason: "every season",
      qualified: "qualified",
      teachers: "teachers",
      CoursesOffer: "Courses we offer",
      appDevelopment: "App Development",
      learn: "Learn how to create IOS and Android ",
      mobilApp: "mobile applications in Bootcamp",
      qualifiedTeacher: "with qualified teachers.",
      viewDetails: "View details",
      fullStack: " Full-stack web ",
      development: "development",
      webDeveloper:
        "  Web developer is highly needed profession in nowadays. Become Full stack  developer in BootcampTm.",
      learnDesign:
        "Learn how to design unique brand identities, product design and user interface",
      productDesign: "Product design",
      dataAnalytics: "Data analytics and business intelligence",
      inThisCourse:
        "In this course learn how to work with large data and how to control the large amount of information",
      whenCome: "When it comes to",
      bootcampIt: "Bootcamp, it's",
      never: "never",
      late: "late",
      to: "to",
      learN: "learn",
      bootcampUnique: "What makes our BootcampTm unique?",
      affordable: "Affordable",
      bootcampPayment:
        "BootcampTm is all about people having another chance in an IT career, that’s why we offer everyone affordable payment plans.",
      professionalSupport: "Professional support",
      everyBatch:
        " Every batch has a limited number of students, so the instructors, mentors, and support team know every student by name and support them in whatever they need.",
      dynamicCurriculum: "Dynamic curriculum",
      everySession:
        "Every session is different. We believe in providing up-to-date knowledge that matches current technology and trend.",
      studentProcess: "Student Process",
      apply: "Apply",
      readDetails:
        "Read the details of the domain you are interested in. Enroll yourself by registering for the specific course.",
      register: "Register",
      signContract: "Sign the contract. Get ready for the course.",
      orientation: "Orientation",
      comeToOrientation:
        "Come to the orientation. Start the class. Know the rules and regulations. Installation of necessary tools and get access to learning materials.",
      careerPreparation: "Career preparation support",
      prepareResume:
        "Prepare your professional resume. Prepare the project descriptions.",
      marketSupport: "Market support",
      followUp:
        "Follow up. Review sessions. Alumni sessions. 1-on-1 support. References and support from our recruiting partners. Sharing job posts. Other job support as needed.",
      finalInterview: "Final interview",
      finalProject: "Final project. MOC interviews. Mentoring.",
      graduate: "Graduate",
      acquireCertification:
        "Acquire certification in the chosen domain. Prepare for a new career.",
      startNewCareer: "Start new career",
      encounterManifold:
        "Encounter manifold career opportunities in your domain.",
      launchLife: "Launch Life",
      sliderText:
        "I am Lyudmila. I am Quality Control Engineer in Industrial Construction. When I was younger, I heard many stories from grandfather who was a civil engineer. The stories inspired me to eventually become an engineer. My advice for woman..I am Lyudmila. I am Quality Control Engineer in Industrial Construction. When I was younger, I heard many stories from grandfather who was a civil engineer.",
      whatOurStudentsSay: "What our students say",
      leaveFeedback: "Leave feedback",
      ourPartners: "Our partners",
      weMake: "We make",
      learning: "learning",
      engaging: "engaging",
      chooseYourDesired: "Choose your desired courses or webinars",
      enrollToday: "Enroll today",
      signintoContinue: "Sign in to Continue",
      password: "Password",
      login: "Login",
      signup: "Sign up",
      continue: "Continue",
      signuptoLearnMore: " Sign up to learn more",
      confirmPassword: "Confirm Password",
      required: "Required",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
